import defaultDir from './default';
import disabled from './disabled';

export default {
  default: defaultDir,
  disabled,
};
